import { Flex, Text, Loader } from '@fluentui/react-northstar';
import AkouoLogo from 'COMPONENTS/AkouoLogo';
import HyperLink from 'COMPONENTS/HyperLink';
import MicrosoftSignInButton from 'COMPONENTS/MicrosoftSignInButton';

// Hooks
import useTabConfig from 'FEATURES/tabConfig/hooks/useTabConfig';

const TabConfig = () => {
  const { t, isAuthorized, authenticate, loading } = useTabConfig();

  // if loading then render loader
  if (loading) {
    return (
      <Flex fill hAlign="center" vAlign="center" column gap="gap.smaller">
        <Loader label={t('LOADING_TEAMS_ACCOUNT')} />
      </Flex>
    );
  }

  return (
    <Flex fill hAlign="center" vAlign="center" column gap="gap.smaller">
      <AkouoLogo width="200px" />
      <Text content={t('WELCOME_MESSAGE')} size="larger" />
      <Text content={t('TAGLINE')} size="medium" align="center" />
      {!isAuthorized && <Text content={t('AUTH_ERROR_MSG')} align="center" />}
      <Text size="small" align="center">
        {t('SUPPORT_LINK')}
        <HyperLink link={`${process.env.REACT_APP_AKOUO_SUPPORT_LINK}`} />
      </Text>
      {!isAuthorized && <MicrosoftSignInButton onClick={authenticate} />}
    </Flex>
  );
};

export default TabConfig;
